import { background } from "@/theme/colors";
import { elevation, rounded } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Stack, StackProps } from "@mui/material";

type TDetailFooterShellProps = {
  justifyContent?: StackProps["justifyContent"];
};

export const DetailFooterShell: FCC<TDetailFooterShellProps> = ({ children, justifyContent = "space-between" }) => {
  return (
    <Stack
      direction="row"
      justifyContent={justifyContent}
      alignItems="center"
      sx={{ background: background.white, borderRadius: rounded.sm, boxShadow: elevation.lv2, padding: "24px" }}
    >
      {children}
    </Stack>
  );
};
